import { render, staticRenderFns } from "./UserTwofaForm.vue?vue&type=template&id=9bcd6ab0&"
import script from "./UserTwofaForm.vue?vue&type=script&lang=js&"
export * from "./UserTwofaForm.vue?vue&type=script&lang=js&"
import style0 from "./UserTwofaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports